import React, { Component } from 'react'
import './detay.css'

class DetayContainer extends Component {
    render() {
        return (
            <div className="det-cont">
                <div className="detay-container-prop">
                    {this.props.prop}
                </div>
                <div className="detay-container-val">
                    {this.props.val}
                </div>
            </div>
        )
    }
}

export default DetayContainer